import createMailFolderTableQuery from '../actions/createMailFolderTableQuery';
import { getCategoryNameFromId, getMasterCategoryList } from 'owa-categories';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
/**
 * Create the table query to load a category search folder
 * @param categoryId the id of the category
 * @return tableQuery the tableQuery that needed to load a mail folder
 */
export default function createMailCategoryFolderTableQuery(categoryId) {
    var categoryName = getCategoryNameFromId(categoryId, getMasterCategoryList());
    var mailCategoryTableQuery = createMailFolderTableQuery(folderNameToId('msgfolderroot'), getListViewTypeForFolder(null), 'category', -1 /* None */, 'UserCategory', categoryName);
    return mailCategoryTableQuery;
}
//# sourceMappingURL=createMailCategoryFolderTableQuery.js.map